exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-615c08d3]{background-image:linear-gradient(45deg,#ccc 25%,transparent 0),linear-gradient(-45deg,#ccc 25%,transparent 0),linear-gradient(45deg,transparent 75%,#ccc 0),linear-gradient(-45deg,transparent 75%,#ccc 0);background-size:16px 16px;background-position:0 0,0 8px,8px -8px,-8px 0}.btn i[data-v-615c08d3]{margin-right:0}.cropper-container.cropper-bg[data-v-615c08d3]{width:100%!important;height:100%!important}", ""]);

// exports
